import * as React from "react";
import { makeStyles } from "@material-ui/core";

import { fontFamily, weight } from "@styles/type.styles";
import { headerColor } from "@styles/color.styles";
import spacing from "@styles/spacing.styles";

export interface TitleProps {
  children: React.ReactNode;
}

const useStyles = makeStyles({
  title: {
    fontFamily,
    fontSize: 36,
    fontWeight: weight.bold,
    lineHeight: "43px",
    marginBottom: 20,
    paddingBottom: spacing.std,
    color: headerColor,
  },
});

export const Title = ({ children }: TitleProps) => {
  const classes = useStyles();
  return <div className={classes.title}>{children}</div>;
};
